
import React from 'react';
import { Star } from 'lucide-react';

interface TestimonialProps {
  quote: string;
  author: string;
  stars: number;
  type: string;
}

const Testimonial = ({ quote, author, stars, type }: TestimonialProps) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow-sm border border-gray-100">
      <div className="flex mb-3">
        {[...Array(5)].map((_, i) => (
          <Star 
            key={i} 
            className={`w-5 h-5 ${i < stars ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'} mr-1`} 
          />
        ))}
      </div>
      <p className="text-gray-700 italic mb-4">"{quote}"</p>
      <div>
        <p className="font-semibold">{author}</p>
        <p className="text-sm text-gray-500">{type}</p>
      </div>
    </div>
  );
};

const BeginnerTestimonials = () => {
  const testimonials = [
    {
      quote: "Som voksen begynder var jeg nervøs for at starte med klaver, men Oscar har gjort det til en fantastisk oplevelse. Hans tålmodighed og evne til at forklare tingene på en enkel måde har gjort hele forskellen.",
      author: "Mette Hansen",
      stars: 5,
      type: "Voksen begynder, 42 år"
    },
    {
      quote: "Min søn på 8 år havde aldrig spillet klaver før, men efter bare få måneder med Oscar spiller han allerede små stykker. Oscar har en særlig evne til at gøre undervisningen sjov og engagerende for børn.",
      author: "Thomas Jensen",
      stars: 5,
      type: "Forælder til begynderelev"
    },
    {
      quote: "Jeg har altid ønsket at lære at spille klaver, men troede det var for sent. Oscar har overbevist mig om det modsatte. Hans undervisning er tilpasset mit niveau og tempo, og jeg nyder hver eneste lektion.",
      author: "Lars Petersen",
      stars: 5,
      type: "Voksen begynder, 56 år"
    }
  ];

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-serif font-bold mb-4">
            Hvad mine begynderelever siger
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Hør fra andre begyndere, der har startet deres klaverrejse med min undervisning.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <Testimonial 
              key={index}
              quote={testimonial.quote}
              author={testimonial.author}
              stars={testimonial.stars}
              type={testimonial.type}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default BeginnerTestimonials;
